import React from 'react';
import { Tabs } from 'antd';

const TabComponent = ({ items, setActiveKey }) => {

    return (
        <Tabs
            defaultActiveKey="1"
            type="card"
            size={'small'}
            style={{
                marginBottom: 32,
            }}
            items={items}
            onChange={(e) => setActiveKey(e)}
        />
    );
};
export default TabComponent;